export default __webpack_public_path__ + "static/media/Job-Journey.ce9fdffd.png";